import { LeadMagnetIdentity, LeadMagnetModel, QuizQuestion } from '@/types/lead-magnet';

import { LEAD_MAGNET_SNAPSHOT_VERSION, LEAD_MAGNET_STORAGE_PREFIX } from './constants';

// Bump only when the structure hash format changes.
const STRUCTURE_VERSION = 1;

const describeQuestion = (question: QuizQuestion) =>
	[
		question.slug,
		...question.answers.map(answer => `${answer.value}${answer.isPass ? '!' : ''}`)
	].join(',');

export const buildStructureHash = (documentId: string, questions: QuizQuestion[]) =>
	[`v${STRUCTURE_VERSION}`, documentId, ...questions.map(describeQuestion)].join('|');

export const buildStorageKey = (documentId: string) =>
	`${LEAD_MAGNET_STORAGE_PREFIX}:${documentId}:v${LEAD_MAGNET_SNAPSHOT_VERSION}`;

export const buildLeadMagnetIdentity = (data: LeadMagnetModel): LeadMagnetIdentity => ({
	storageKey: buildStorageKey(data.documentId),
	structureHash: buildStructureHash(data.documentId, data.questions)
});
